module.exports = __webpack_public_path__ + "static/img/qr_code.2688a7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/qr_code.jpg
// module id = 3Syv
// module chunks = 4